// THIS FILE IS AUTO-GENERATED. DO NOT EDIT DIRECTLY

/* eslint no-unused-vars: 0 */ import * as Api from '../apiModels';
import { FetchResponse } from '../fetchResponse';
import {
  GetAsync,
  PostAsync,
  PatchAsync,
  PutAsync,
  DeleteAsync
} from '@maxpreps/network/src/simpleWrapper';
import { CsString } from '../cs-mappers/CsString';
import { CsGuid } from '../cs-mappers/CsGuid';

const GetPublicUrl = (checkCache: Boolean) =>
  checkCache ? 'public/' : CsString.empty;

export const GetContestBasicAsync = async (
  teamId: string,
  sportSeasonId: string,
  contestId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestBasic>> =>
  GetAsync<Api.ContestBasic>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/contests/${contestId}/basic/v1`,
    token,
    headers
  );
export const GetTeamContestsBasicAsync = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestBasic[]>> =>
  GetAsync<Api.ContestBasic[]>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/contests/basic/v1`,
    token,
    headers
  );
export const GetContestIdsByDateRangeAsync = async (
  startDate: string,
  endDate: string,
  includeDeleted: Boolean = false,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string[]>> =>
  GetAsync<string[]>(
    `contests/contest-ids/v1?startdate=${startDate}&enddate=${endDate}&includedeleted=${includeDeleted}`,
    token,
    headers
  );
export const CreateContestAsync = async (
  contest: Api.ContestBasic,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestBasic>> =>
  PostAsync<Api.ContestBasic>(`contests/v1`, contest, token, headers);
export const CreateContestAsync2 = async (
  teamId: string,
  sportSeasonId: string,
  contest: Api.ContestBasic,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestBasic>> =>
  PostAsync<Api.ContestBasic>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/contests/v1`,
    contest,
    token,
    headers
  );
export const UpdateTeamContestAsync = async (
  contest: Api.ContestBasic,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestBasic>> =>
  PutAsync<Api.ContestBasic>(
    `contests/${contest.contestId}/v1`,
    contest,
    token,
    headers
  );
export const UpdateTeamContestAsync2 = async (
  teamId: string,
  sportSeasonId: string,
  contest: Api.ContestBasic,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestBasic>> =>
  PutAsync<Api.ContestBasic>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/contests/${contest.contestId}/v1`,
    contest,
    token,
    headers
  );
export const RestoreContestAsync = async (
  contestId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestBasic>> =>
  PostAsync<Api.ContestBasic>(
    `contests/${contestId}/restore/v1`,
    null,
    token,
    headers
  );
export const PurgeContestCacheAsync = async (
  contestId: string,
  purgeType: Api.CachePurgeType,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> =>
  PostAsync<string>(
    `contests/${contestId}/purge/${purgeType}/v1`,
    null,
    token,
    headers
  );
export const DeleteContestAsync = async (
  contestId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestBasic>> =>
  DeleteAsync<Api.ContestBasic>(
    `contests/${contestId}/remove/v1`,
    token,
    headers
  );
export const GetContestCalculatedFieldsAsync = async (
  contest: Api.ContestBasic,
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestCalculatedFields>> =>
  PostAsync<Api.ContestCalculatedFields>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/contests/calculated-fields/v1`,
    contest,
    token,
    headers
  );
export const GetApiContestsByTeamIdsAndSsidBulkAsync = async (
  teamIds: string[],
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestBasic[]>> =>
  PostAsync<Api.ContestBasic[]>(
    `contests/teams/bulk/sportseasons/${sportSeasonId}/basic/v1`,
    teamIds,
    token,
    headers
  );
export const UpdateContestUrlsAsync = async (
  contestId: string,
  contestUpdateMessage: Api.ContestUpdate,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  PostAsync<any>(
    `contests/${contestId}/url-update/v1`,
    contestUpdateMessage,
    token,
    headers
  );
export const GetApiContestsBulkAsync = async (
  contestIds: string[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestBasic[]>> =>
  PostAsync<Api.ContestBasic[]>(
    `contests/bulk/basic/v1`,
    contestIds,
    token,
    headers
  );
export const CopyScheduleAsync = async (
  teamId: string,
  sportSeasonId: string,
  item: Api.CopyScheduleInfo,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestBasic[]>> =>
  PostAsync<Api.ContestBasic[]>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/copy-schedule/v1`,
    item,
    token,
    headers
  );
export const GetContestScorerSignUpInfoAsync = async (
  contestId: string,
  userId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestScorerSignUpInfo>> =>
  GetAsync<Api.ContestScorerSignUpInfo>(
    `contests/${contestId}/users/${userId}/scorer-signup-info/v1`,
    token,
    headers
  );
export const GetContestV2OffloadAsync = async (
  contestId: string,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestSingleSp>> =>
  GetAsync<Api.ContestSingleSp>(
    `contests/${contestId}/${GetPublicUrl(checkCache)}v0`,
    token,
    headers
  );
export const GetContestsByTeamOffloadAsync = async (
  teamId: string,
  sportSeasonId: string,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestCompleteWithHudl>> =>
  GetAsync<Api.ContestCompleteWithHudl>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/contests/${GetPublicUrl(
      checkCache
    )}v0`,
    token,
    headers
  );
export const GetContestsByTeamsOffloadBulkAsync = async (
  teamIds: string[],
  sportSeasonId: string,
  liveDate: string | null,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestWithQwixcoreSp>> =>
  PostAsync<Api.ContestWithQwixcoreSp>(
    `contests/teams/bulk/sportseasons/${sportSeasonId}/live-contests/${GetPublicUrl(
      checkCache
    )}v0?liveDate=${liveDate}`,
    teamIds,
    token,
    headers
  );
export const GetContestsByLeagueOffloadAsync = async (
  leagueId: string,
  startDate: string | null,
  endDate: string | null,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestCompleteSp>> =>
  GetAsync<Api.ContestCompleteSp>(
    `contests/leagues/${leagueId}/contests/${GetPublicUrl(
      checkCache
    )}v0?startDate=${startDate}&endDate=${endDate}`,
    token,
    headers
  );
export const GetLiveContestsByLeagueOffloadAsync = async (
  leagueId: string,
  liveDate: string | null,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestWithQwixcoreSp>> =>
  GetAsync<Api.ContestWithQwixcoreSp>(
    `contests/leagues/${leagueId}/live-contests/${GetPublicUrl(
      checkCache
    )}v0?liveDate=${liveDate}`,
    token,
    headers
  );
export const GetContestsBySectionOffloadAsync = async (
  sectionId: string,
  sportSeasonId: string,
  startDate: string | null,
  endDate: string | null,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestCompleteSp>> =>
  GetAsync<Api.ContestCompleteSp>(
    `contests/sections/${sectionId}/sportseasons/${sportSeasonId}/contests/${GetPublicUrl(
      checkCache
    )}v0?startDate=${startDate}&endDate=${endDate}`,
    token,
    headers
  );
export const GetLiveContestsBySectionOffloadAsync = async (
  sectionId: string,
  sportSeasonId: string,
  liveDate: string | null,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestWithQwixcoreSp>> =>
  GetAsync<Api.ContestWithQwixcoreSp>(
    `contests/sections/${sectionId}/sportseasons/${sportSeasonId}/live-contests/${GetPublicUrl(
      checkCache
    )}v0?liveDate=${liveDate}`,
    token,
    headers
  );
export const GetContestsByAssociationOffloadAsync = async (
  associationId: string,
  sportSeasonId: string,
  startDate: string | null,
  endDate: string | null,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestCompleteSp>> =>
  GetAsync<Api.ContestCompleteSp>(
    `contests/associations/${associationId}/sportseasons/${sportSeasonId}/contests/${GetPublicUrl(
      checkCache
    )}v0?startDate=${startDate}&endDate=${endDate}`,
    token,
    headers
  );
export const GetLiveContestsByAssociationOffloadAsync = async (
  associationId: string,
  sportSeasonId: string,
  liveDate: string | null,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestWithQwixcoreSp>> =>
  GetAsync<Api.ContestWithQwixcoreSp>(
    `contests/associations/${associationId}/sportseasons/${sportSeasonId}/live-contests/${GetPublicUrl(
      checkCache
    )}v0?liveDate=${liveDate}`,
    token,
    headers
  );
export const GetContestsBySectionDivisionOffloadAsync = async (
  sectionDivisionId: string,
  sportSeasonId: string,
  startDate: string | null,
  endDate: string | null,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestCompleteSp>> =>
  GetAsync<Api.ContestCompleteSp>(
    `contests/section-divisions/${sectionDivisionId}/sportseasons/${sportSeasonId}/contests/${GetPublicUrl(
      checkCache
    )}v0?startDate=${startDate}&endDate=${endDate}`,
    token,
    headers
  );
export const GetLiveContestsBySectionDivisionOffloadAsync = async (
  sectionDivisionId: string,
  sportSeasonId: string,
  liveDate: string | null,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestWithQwixcoreSp>> =>
  GetAsync<Api.ContestWithQwixcoreSp>(
    `contests/section-divisions/${sectionDivisionId}/sportseasons/${sportSeasonId}/live-contests/${GetPublicUrl(
      checkCache
    )}v0?liveDate=${liveDate}`,
    token,
    headers
  );
export const GetContestsByStateDivisionOffloadAsync = async (
  stateDivisionId: string,
  sportSeasonId: string,
  startDate: string | null,
  endDate: string | null,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestCompleteSp>> =>
  GetAsync<Api.ContestCompleteSp>(
    `contests/state-divisions/${stateDivisionId}/sportseasons/${sportSeasonId}/contests/${GetPublicUrl(
      checkCache
    )}v0?startDate=${startDate}&endDate=${endDate}`,
    token,
    headers
  );
export const GetLiveContestsByStateDivisionOffloadAsync = async (
  stateDivisionId: string,
  sportSeasonId: string,
  liveDate: string | null,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestWithQwixcoreSp>> =>
  GetAsync<Api.ContestWithQwixcoreSp>(
    `contests/state-divisions/${stateDivisionId}/sportseasons/${sportSeasonId}/live-contests/${GetPublicUrl(
      checkCache
    )}v0?liveDate=${liveDate}`,
    token,
    headers
  );
export const GetContestsByDmaOffloadAsync = async (
  dmaId: string,
  sportSeasonId: string,
  startDate: string | null,
  endDate: string | null,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestCompleteSp>> =>
  GetAsync<Api.ContestCompleteSp>(
    `contests/dmas/${dmaId}/sportseasons/${sportSeasonId}/contests/${GetPublicUrl(
      checkCache
    )}v0?startDate=${startDate}&endDate=${endDate}`,
    token,
    headers
  );
export const GetLiveContestsByDmaOffloadAsync = async (
  dmaId: string,
  sportSeasonId: string,
  liveDate: string | null,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestWithQwixcoreSp>> =>
  GetAsync<Api.ContestWithQwixcoreSp>(
    `contests/dmas/${dmaId}/sportseasons/${sportSeasonId}/live-contests/${GetPublicUrl(
      checkCache
    )}v0?liveDate=${liveDate}`,
    token,
    headers
  );
export const GetContestsByStateOffloadAsync = async (
  stateId: string,
  sportSeasonId: string,
  startDate: string | null,
  endDate: string | null,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestCompleteSp>> =>
  GetAsync<Api.ContestCompleteSp>(
    `contests/states/${stateId}/sportseasons/${sportSeasonId}/contests/${GetPublicUrl(
      checkCache
    )}v0?startDate=${startDate}&endDate=${endDate}`,
    token,
    headers
  );
export const GetLiveContestsByStateOffloadAsync = async (
  stateId: string,
  sportSeasonId: string,
  liveDate: string | null,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestWithQwixcoreSp>> =>
  GetAsync<Api.ContestWithQwixcoreSp>(
    `contests/states/${stateId}/sportseasons/${sportSeasonId}/live-contests/${GetPublicUrl(
      checkCache
    )}v0?liveDate=${liveDate}`,
    token,
    headers
  );
export const GetContestsByHolidayClassicOffloadAsync = async (
  sportSeasonId: string,
  startDate: string | null,
  endDate: string | null,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestCompleteSp>> =>
  GetAsync<Api.ContestCompleteSp>(
    `contests/holiday-classics/sportseasons/${sportSeasonId}/contests/${GetPublicUrl(
      checkCache
    )}v0?startDate=${startDate}&endDate=${endDate}`,
    token,
    headers
  );
export const GetLiveContestsByHolidayClassicOffloadAsync = async (
  sportSeasonId: string,
  liveDate: string | null,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestWithQwixcoreSp>> =>
  GetAsync<Api.ContestWithQwixcoreSp>(
    `contests/holiday-classics/sportseasons/${sportSeasonId}/live-contests/${GetPublicUrl(
      checkCache
    )}v0?liveDate=${liveDate}`,
    token,
    headers
  );
export const GetContestsByCareerOffloadAsync = async (
  careerId: string,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestCompleteSp>> =>
  GetAsync<Api.ContestCompleteSp>(
    `contests/careers/${careerId}/contests/${GetPublicUrl(checkCache)}v0`,
    token,
    headers
  );
export const GetTournamentsByBulkContestsIdsAsync = async (
  contestIds: string[],
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TournamentsCommonOffload[]>> =>
  PostAsync<Api.TournamentsCommonOffload[]>(
    `contests/bulk/tournaments/${GetPublicUrl(checkCache)}v0`,
    contestIds,
    token,
    headers
  );
export const GetTournamentByContestIdAsync = async (
  contestId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestTournament>> =>
  GetAsync<Api.ContestTournament>(
    `contests/${contestId}/tournaments/v0`,
    token,
    headers
  );
export const GetHudlInfoByBulkContestsIdsAsync = async (
  contestIds: string[],
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.HudlInfoCommonOffload[]>> =>
  PostAsync<Api.HudlInfoCommonOffload[]>(
    `contests/bulk/hudl-info/${GetPublicUrl(checkCache)}v0`,
    contestIds,
    token,
    headers
  );
export const GetQwixcoreContestsByUserAsync = async (
  userId: string,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreWithContestSp>> =>
  GetAsync<Api.QwixcoreWithContestSp>(
    `contests/users/${userId}/qwixcore-contests/${GetPublicUrl(checkCache)}v0`,
    token,
    headers
  );
export const GetQwixcoreContestsByDmaAsync = async (
  dmaId: string,
  sportSeasonId: string,
  startDate: string | null,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreWithContestSp>> =>
  GetAsync<Api.QwixcoreWithContestSp>(
    `contests/dmas/${dmaId}/sportseasons/${sportSeasonId}/qwixcore-contests/${GetPublicUrl(
      checkCache
    )}v0?startDate=${startDate}`,
    token,
    headers
  );
export const GetCompleteQwixcoreContestsByContestIdAsync = async (
  contestId: string,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreCompleteSp>> =>
  GetAsync<Api.QwixcoreCompleteSp>(
    `contests/${contestId}/qwixcore-contests/${GetPublicUrl(checkCache)}v0`,
    token,
    headers
  );
export const GetCompleteQwixcoreContestsByQwixcoreGameIdAsync = async (
  qwixcoreGameId: string,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreCompleteSp>> =>
  GetAsync<Api.QwixcoreCompleteSp>(
    `contests/qwixcore-games/${qwixcoreGameId}/qwixcore-contests/${GetPublicUrl(
      checkCache
    )}v0`,
    token,
    headers
  );
export const GetCompleteQwixcoreContestsByActiveWithInactivityPublicAsync =
  async (
    token: string = '',
    headers: object | null = {}
  ): Promise<FetchResponse<Api.QwixcoreContestWithInactivitySp>> =>
    GetAsync<Api.QwixcoreContestWithInactivitySp>(
      `contests/qwixcore-contests/inactivity/public/v0`,
      token,
      headers
    );
export const GetQwixcoreBasicByPartnerStateGameAsync = async (
  partnerGameId: string,
  partnerCode: number,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreBasicSp>> =>
  GetAsync<Api.QwixcoreBasicSp>(
    `contests/partner-games/${partnerGameId}/partner-codes/${partnerCode}/qwixcore-basics/${GetPublicUrl(
      checkCache
    )}v0`,
    token,
    headers
  );
export const GetCompleteQwixcoreBasicByQwixcoreGameIdAsync = async (
  qwixcoreGameId: string,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreBasicSp>> =>
  GetAsync<Api.QwixcoreBasicSp>(
    `contests/qwixcore-games/${qwixcoreGameId}/qwixcore-basics/${GetPublicUrl(
      checkCache
    )}v0`,
    token,
    headers
  );
export const GetQwixcoreBasicByPartnerStateAsync = async (
  stateCode: string,
  sportSeasonId: string,
  partnerCode: number,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreBasicWithPartnerSp>> =>
  GetAsync<Api.QwixcoreBasicWithPartnerSp>(
    `contests/states/${stateCode}/sportseasons/${sportSeasonId}/partner-codes/${partnerCode}/qwixcore-basics/${GetPublicUrl(
      checkCache
    )}v0`,
    token,
    headers
  );
export const GetContestBasicScorerByContestIdAsync = async (
  contestId: string,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestBasicWithScorerSp>> =>
  GetAsync<Api.ContestBasicWithScorerSp>(
    `contests/${contestId}/contest-basic-scorers/${GetPublicUrl(checkCache)}v0`,
    token,
    headers
  );
export const GetContestBasicScorerByUserIdAsync = async (
  userId: string,
  checkCache: Boolean,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestBasicWithScorerSp>> =>
  GetAsync<Api.ContestBasicWithScorerSp>(
    `contests/users/${userId}/contest-basic-scorers/${GetPublicUrl(
      checkCache
    )}v0`,
    token,
    headers
  );
export const GetCompleteQwixcoreLogsByQwixcoreGameIdAdminAsync = async (
  qwixcoreGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreLogsSp>> =>
  GetAsync<Api.QwixcoreLogsSp>(
    `contests/qwixcore-games/${qwixcoreGameId}/qwixcore-logs/v0`,
    token,
    headers
  );
export const GetPlayersOfTheGameByContestAsync = async (
  contestId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.PlayerOfTheGame[]>> =>
  GetAsync<Api.PlayerOfTheGame[]>(
    `contests/${contestId}/playerofthegame/v1`,
    token,
    headers
  );
export const GetPlayersOfTheGameByContestDetailsAsync = async (
  teamId: string,
  sportSeasonId: string,
  contestId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.PlayerOfTheGame[]>> =>
  GetAsync<Api.PlayerOfTheGame[]>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/contests/${contestId}/playerofthegame/v1`,
    token,
    headers
  );
export const GetPlayersOfTheGameByTeamAsync = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.PlayerOfTheGame[]>> =>
  GetAsync<Api.PlayerOfTheGame[]>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/playerofthegame/v1`,
    token,
    headers
  );
export const GetPlayerOfTheGameAsync = async (
  teamId: string,
  sportSeasonId: string,
  playerOfTheGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.PlayerOfTheGame>> =>
  GetAsync<Api.PlayerOfTheGame>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/playerofthegame/${playerOfTheGameId}/v1`,
    token,
    headers
  );
export const GetPlayersOfTheGameByAthleteBulkAsync = async (
  baseAthletes: Api.BaseAthlete[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.PlayerOfTheGame[]>> =>
  PostAsync<Api.PlayerOfTheGame[]>(
    'contests/athletes/bulk/playersofthegame/v1',
    baseAthletes,
    token,
    headers
  );
export const CreatePlayerOfTheGameAsync = async (
  teamId: string,
  sportSeasonId: string,
  player: Api.PlayerOfTheGame,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.PlayerOfTheGame>> =>
  PostAsync<Api.PlayerOfTheGame>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/playerofthegame/v1`,
    player,
    token,
    headers
  );
export const UpdatePlayerOfTheGameAsync = async (
  teamId: string,
  sportSeasonId: string,
  playerOfTheGameId: string,
  updatedPotg: Api.PlayerOfTheGame,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.PlayerOfTheGame>> =>
  PutAsync<Api.PlayerOfTheGame>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/playerofthegame/${playerOfTheGameId}/v1`,
    updatedPotg,
    token,
    headers
  );
export const DeletePlayerOfTheGameAsync = async (
  teamId: string,
  sportSeasonId: string,
  playerOfTheGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  DeleteAsync<any>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/playerofthegame/${playerOfTheGameId}/v1`,
    token,
    headers
  );
export const GetPlayerOfTheYearAsync = async (
  teamId: string,
  sportSeasonId: string,
  playerOfTheYearId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.PlayerOfTheYear>> =>
  GetAsync<Api.PlayerOfTheYear>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/playeroftheyear/${playerOfTheYearId}/v1`,
    token,
    headers
  );
export const GetPlayerOfTheYearAsync2 = async (
  playerOfTheYearId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.PlayerOfTheYear>> =>
  GetAsync<Api.PlayerOfTheYear>(
    `contests/playersoftheyear/${playerOfTheYearId}/v1`,
    token,
    headers
  );
export const GetPlayersOfTheYearAsync = async (
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.PlayerOfTheYear[]>> =>
  GetAsync<Api.PlayerOfTheYear[]>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/playersoftheyear/v1`,
    token,
    headers
  );
export const GetPlayersOfTheYearByAthleteBulkAsync = async (
  baseAthletes: Api.BaseAthlete[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.PlayerOfTheYear[]>> =>
  PostAsync<Api.PlayerOfTheYear[]>(
    'contests/athletes/bulk/playersoftheyear/v1',
    baseAthletes,
    token,
    headers
  );
export const CreatePlayerOfTheYearAsync = async (
  teamId: string,
  sportSeasonId: string,
  player: Api.PlayerOfTheYear,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.PlayerOfTheYear>> =>
  PostAsync<Api.PlayerOfTheYear>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/playeroftheyear/v1`,
    player,
    token,
    headers
  );
export const DeletePlayerOfTheYearAsync = async (
  teamId: string,
  sportSeasonId: string,
  playerOfTheYearId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  DeleteAsync<any>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/playeroftheyear/${playerOfTheYearId}/v1`,
    token,
    headers
  );
export const GetInGameScoreDataAsync = async (
  contestId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.InGameScoreData[]>> =>
  GetAsync<Api.InGameScoreData[]>(
    `contests/${contestId}/in-game-score-data/v1`,
    token,
    headers
  );
export const GetInGameScoreDataByIdAsync = async (
  inGameScoreDataId: number,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.InGameScoreData>> =>
  GetAsync<Api.InGameScoreData>(
    `contests/in-game-score-data/${inGameScoreDataId}/v1`,
    token,
    headers
  );
export const CreateInGameScoreDataByAsync = async (
  inGameScoreData: Api.InGameScoreData,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.InGameScoreData>> =>
  PostAsync<Api.InGameScoreData>(
    'contests/in-game-score-data/v1',
    inGameScoreData,
    token,
    headers
  );
export const RemoveInGameScoreDataByAsync = async (
  inGameScoreDataId: number,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  DeleteAsync<any>(
    `contests/in-game-score-data/${inGameScoreDataId}/remove/v1`,
    token,
    headers
  );
export const RemoveInGameScoreDataByAsync2 = async (
  contestId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  DeleteAsync<any>(
    `contests/${contestId}/in-game-score-data/remove/v1`,
    token,
    headers
  );
export const GetQwixcoreGameByIdAsync = async (
  qwixcoreGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGame>> =>
  GetAsync<Api.QwixcoreGame>(
    `contests/qwixcore-games/${qwixcoreGameId}/v1`,
    token,
    headers
  );
export const GetQwixcoreGameByContestAsync = async (
  contestId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGame[]>> =>
  GetAsync<Api.QwixcoreGame[]>(
    `contests/${contestId}/qwixcore-games/v1`,
    token,
    headers
  );
export const GetActiveQwixcoreGameByUserAsync = async (
  userId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGame[]>> =>
  GetAsync<Api.QwixcoreGame[]>(
    `contests/users/${userId}/qwixcore-games/v1`,
    token,
    headers
  );
export const GetQwixcoreGamesByBulkContestIdsAsync = async (
  contestIds: string[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGame[]>> =>
  PostAsync<Api.QwixcoreGame[]>(
    `contests/bulk/qwixcore-games/v1`,
    contestIds,
    token,
    headers
  );
export const GetQwixcoreGamesByBulkQwixcoreGameIdsAsync = async (
  qwixcoreGameIds: string[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGame[]>> =>
  PostAsync<Api.QwixcoreGame[]>(
    `contests/qwixcore-games/bulk/v1`,
    qwixcoreGameIds,
    token,
    headers
  );
export const GetQwixcoreGamesByIsGameCompletedAsync = async (
  isGameCompleted: Boolean = false,
  daysBack: number = 0,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGame[]>> =>
  GetAsync<Api.QwixcoreGame[]>(
    `contests/qwixcore-games/v1?isgamecompleted=${isGameCompleted}&daysback=${daysBack}`,
    token,
    headers
  );
export const DeleteQwixcoreGameAsync = async (
  qwixcoreGameId: string,
  currentStatus: Api.ScorerRequestStatus,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  DeleteAsync<any>(
    `contests/qwixcore-games/${qwixcoreGameId}/status/${currentStatus}/delete/v1`,
    token,
    headers
  );
export const CreateQwixcoreGameAsync = async (
  qwixcoreGame: Api.QwixcoreGame,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGame>> =>
  PostAsync<Api.QwixcoreGame>(
    `contests/qwixcore-games/v1`,
    qwixcoreGame,
    token,
    headers
  );
export const PatchQwixcoreGameAsync = async (
  qwixcoreGameId: string,
  updates: any[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGame>> =>
  PatchAsync<Api.QwixcoreGame>(
    `contests/qwixcore-games/${qwixcoreGameId}/v1`,
    updates,
    token,
    headers
  );
export const GetQwixcoreGameViewCountAsync = async (
  qwixcoreGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameViewCount>> =>
  GetAsync<Api.QwixcoreGameViewCount>(
    `contests/qwixcore-games/${qwixcoreGameId}/view-counts/v1`,
    token,
    headers
  );
export const IncrementQwixcoreGameViewCountAsync = async (
  qwixcoreGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  PostAsync<any>(
    `contests/qwixcore-games/${qwixcoreGameId}/view-counts/increment/v1`,
    null,
    token,
    headers
  );
export const ResetQwixcoreGameAsync = async (
  qwixcoreGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  PostAsync<any>(
    `contests/qwixcore-games/${qwixcoreGameId}/reset/v1`,
    null,
    token,
    headers
  );
export const AssignScorerToQwixcoreGameAsync = async (
  qwixcoreGameId: string,
  assignScorerData: Api.QwixcoreScorerRequest,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  PostAsync<any>(
    `contests/qwixcore-games/${qwixcoreGameId}/assign-scorer/v1`,
    assignScorerData,
    token,
    headers
  );
export const RemoveScorerFromQwixcoreGameAsync = async (
  qwixcoreGameId: string,
  removeScorerData: Api.QwixcoreScorerRequest,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  PostAsync<any>(
    `contests/qwixcore-games/${qwixcoreGameId}/remove-scorer/v1`,
    removeScorerData,
    token,
    headers
  );
export const PurgeQwixcoreGameCacheAsync = async (
  qwixcoreGameId: string,
  purgeType: Api.CachePurgeType,
  contestId: string | null = null,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> => {
  var queryString = CsString.empty;
  if (contestId !== CsGuid.empty) {
    queryString = `?contestId=${contestId}`;
  }

  return PostAsync<string>(
    `contests/qwixcore-games/${qwixcoreGameId}/purge/${purgeType}/v1${queryString}`,
    null,
    token,
    headers
  );
};
export const GetQwixcoreGameDataByIdAsync = async (
  qwixcoreGameDataId: number,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameData>> =>
  GetAsync<Api.QwixcoreGameData>(
    `contests/qwixcore-game-data/${qwixcoreGameDataId}/v1`,
    token,
    headers
  );
export const GetQwixcoreGameDataByQwixcoreGameIdAsync = async (
  qwixcoreGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameData[]>> =>
  GetAsync<Api.QwixcoreGameData[]>(
    `contests/qwixcore-games/${qwixcoreGameId}/qwixcore-game-data/v1`,
    token,
    headers
  );
export const GetQwixcoreGameDataByBulkQwixcoreGameIdAsync = async (
  qwixcoreGameIds: string[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameData[]>> =>
  PostAsync<Api.QwixcoreGameData[]>(
    `contests/qwixcore-games/bulk/qwixcore-game-data/v1`,
    qwixcoreGameIds,
    token,
    headers
  );
export const CreateQwixcoreGameDataAsync = async (
  qwixcoreGameData: Api.QwixcoreGameData,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameData>> =>
  PostAsync<Api.QwixcoreGameData>(
    `contests/qwixcore-game-data/v1`,
    qwixcoreGameData,
    token,
    headers
  );
export const PatchQwixcoreGameDataAsync = async (
  qwixcoreGameDataId: number,
  updates: any[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameData>> =>
  PatchAsync<Api.QwixcoreGameData>(
    `contests/qwixcore-game-data/${qwixcoreGameDataId}/v1`,
    updates,
    token,
    headers
  );
export const DestroyQwixcoreGameDataByIdAsync = async (
  qwixcoreGameDataId: number,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  DeleteAsync<any>(
    `contests/qwixcore-game-data/${qwixcoreGameDataId}/v1`,
    token,
    headers
  );
export const DestroyQwixcoreGameDataByQwixcoreGameIdAsync = async (
  qwixcoreGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  DeleteAsync<any>(
    `contests/qwixcore-games/${qwixcoreGameId}/qwixcore-game-data/v1`,
    token,
    headers
  );
export const PurgeQwixcoreGameDataCacheAsync = async (
  qwixcoreGameDataId: number,
  purgeType: Api.CachePurgeType,
  qwixcoreGameId: string | null = null,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> => {
  var queryString = CsString.empty;
  if (qwixcoreGameId && qwixcoreGameId !== CsGuid.empty) {
    queryString = `?qwixcoreGameId=${qwixcoreGameId}`;
  }

  return PostAsync<string>(
    `contests/qwixcore-game-data/${qwixcoreGameDataId}/purge/${purgeType}/v1${queryString}`,
    null,
    token,
    headers
  );
};
export const GetQwixcoreGameSchoolAsync = async (
  qwixcoreGameSchoolId: number,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameSchool>> =>
  GetAsync<Api.QwixcoreGameSchool>(
    `contests/qwixcore-game-schools/${qwixcoreGameSchoolId}/v1`,
    token,
    headers
  );
export const GetQwixcoreGameSchoolsByBulkAsync = async (
  qwixcoreGameIds: string[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameSchool[]>> =>
  PostAsync<Api.QwixcoreGameSchool[]>(
    `contests/qwixcore-games/bulk/qwixcore-game-schools/v1`,
    qwixcoreGameIds,
    token,
    headers
  );
export const AddQwixcoreGameSchoolAsync = async (
  qwixcoreGameSchool: Api.QwixcoreGameSchool,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameSchool>> =>
  PostAsync<Api.QwixcoreGameSchool>(
    `contests/qwixcore-game-schools/v1`,
    qwixcoreGameSchool,
    token,
    headers
  );
export const DeleteQwixcoreGameSchoolAsync = async (
  qwixcoreGameSchoolId: number,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  DeleteAsync<any>(
    `contests/qwixcore-game-schools/${qwixcoreGameSchoolId}/v1`,
    token,
    headers
  );
export const DeleteQwixcoreGameSchoolAsync2 = async (
  qwixcoreGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  DeleteAsync<any>(
    `contests/qwixcore-games/${qwixcoreGameId}/qwixcore-game-schools/v1`,
    token,
    headers
  );
export const CreateQwixcoreGamePeriodAsync = async (
  qwixcoreGamePeriod: Api.QwixcoreGamePeriod,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGamePeriod>> =>
  PostAsync<Api.QwixcoreGamePeriod>(
    'contests/qwixcore-game-periods/v1',
    qwixcoreGamePeriod,
    token,
    headers
  );
export const CreateQwixcoreGamePeriodsBulkAsync = async (
  qwixcoreGamePeriods: Api.QwixcoreGamePeriod[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGamePeriod[]>> =>
  PostAsync<Api.QwixcoreGamePeriod[]>(
    'contests/qwixcore-game-periods/bulk/v1',
    qwixcoreGamePeriods,
    token,
    headers
  );
export const GetQwixcoreGamePeriodByIdAsync = async (
  qwixcoreGamePeriodId: number,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGamePeriod>> =>
  GetAsync<Api.QwixcoreGamePeriod>(
    `contests/qwixcore-game-periods/${qwixcoreGamePeriodId}/v1`,
    token,
    headers
  );
export const GetQwixcoreGamePeriodsByQwixcoreGameIdAsync = async (
  qwixcoreGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGamePeriod[]>> =>
  GetAsync<Api.QwixcoreGamePeriod[]>(
    `contests/qwixcore-games/${qwixcoreGameId}/qwixcore-game-periods/v1`,
    token,
    headers
  );
export const GetQwixcorePeriodsByBulkQwixcoreGameIdsAsync = async (
  qwixcoreGameIds: string[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGamePeriod[]>> =>
  PostAsync<Api.QwixcoreGamePeriod[]>(
    `contests/qwixcore-games/bulk/qwixcore-game-periods/v1`,
    qwixcoreGameIds,
    token,
    headers
  );
export const PatchQwixcoreGamePeriodAsync = async (
  qwixcoreGamePeriodId: number,
  updates: any[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGamePeriod>> =>
  PatchAsync<Api.QwixcoreGamePeriod>(
    `contests/qwixcore-game-periods/${qwixcoreGamePeriodId}/v1`,
    updates,
    token,
    headers
  );
export const DeleteQwixcoreGamePeriodByIdAsync = async (
  qwixcoreGamePeriodId: number,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  DeleteAsync<any>(
    `contests/qwixcore-game-periods/${qwixcoreGamePeriodId}/v1`,
    token,
    headers
  );
export const DeleteQwixcoreGamePeriodsByQwixcoreGameIdAsync = async (
  qwixcoreGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  DeleteAsync<any>(
    `contests/qwixcore-games/${qwixcoreGameId}/qwixcore-game-periods/v1`,
    token,
    headers
  );
export const PurgeQwixcoreGamePeriodCacheAsync = async (
  qwixcoreGamePeriodId: number,
  purgeType: Api.CachePurgeType,
  qwixcoreGameId: string | null = null,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> => {
  var queryString = CsString.empty;
  if (qwixcoreGameId && qwixcoreGameId !== CsGuid.empty) {
    queryString = `?qwixcoreGameId=${qwixcoreGameId}`;
  }

  return PostAsync<string>(
    `contests/qwixcore-game-periods/${qwixcoreGamePeriodId}/purge/${purgeType}/v1${queryString}`,
    null,
    token,
    headers
  );
};
export const GetQwixcoreGameNotificationHistoryByIdAsync = async (
  qwixcoreGameNotificationHistoryId: number,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameNotificationHistory>> =>
  GetAsync<Api.QwixcoreGameNotificationHistory>(
    `contests/qwixcore-game-notification-history/${qwixcoreGameNotificationHistoryId}/v1`,
    token,
    headers
  );
export const GetQwixcoreGameNotificationHistoryByQwixcoreGameIdAsync = async (
  qwixcoreGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameNotificationHistory[]>> =>
  GetAsync<Api.QwixcoreGameNotificationHistory[]>(
    `contests/qwixcore-games/${qwixcoreGameId}/qwixcore-game-notification-history/v1`,
    token,
    headers
  );
export const CreateQwixcoreGameNotificationHistoryAsync = async (
  qwixcoreGameNotificationHistory: Api.QwixcoreGameNotificationHistory,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameNotificationHistory>> =>
  PostAsync<Api.QwixcoreGameNotificationHistory>(
    `contests/qwixcore-game-notification-history/v1`,
    qwixcoreGameNotificationHistory,
    token,
    headers
  );
export const DestroyQwixcoreGameNotificationHistoryByIdAsync = async (
  qwixcoreGameNotificationHistoryId: number,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  DeleteAsync<any>(
    `contests/qwixcore-game-notification-history/${qwixcoreGameNotificationHistoryId}/v1`,
    token,
    headers
  );
export const DestroyQwixcoreGameNotificationHistoryByQwixcoreGameIdAsync =
  async (
    qwixcoreGameId: string,
    token: string = '',
    headers: object | null = {}
  ): Promise<FetchResponse<any>> =>
    DeleteAsync<any>(
      `contests/qwixcore-games/${qwixcoreGameId}/qwixcore-game-notification-history/v1`,
      token,
      headers
    );
export const PurgeQwixcoreGameNotificationHistoryCacheAsync = async (
  qwixcoreGameNotificationHistoryId: number,
  purgeType: Api.CachePurgeType,
  qwixcoreGameId: string | null = null,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> => {
  var queryString = CsString.empty;
  if (qwixcoreGameId && qwixcoreGameId !== CsGuid.empty) {
    queryString = `?qwixcoreGameId=${qwixcoreGameId}`;
  }

  return PostAsync<string>(
    `contests/qwixcore-game-notification-history/${qwixcoreGameNotificationHistoryId}/purge/${purgeType}/v1${queryString}`,
    null,
    token,
    headers
  );
};
export const GetQwixcoreGameAlertAbuseReportAsync = async (
  abuseReportId: number,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameAlertAbuseReport>> =>
  GetAsync<Api.QwixcoreGameAlertAbuseReport>(
    `contests/alert-abuse-reports/${abuseReportId}/v1`,
    token,
    headers
  );
export const GetQwixcoreGameAlertAbuseReportsByGameIdAsync = async (
  qwixcoreGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameAlertAbuseReport[]>> =>
  GetAsync<Api.QwixcoreGameAlertAbuseReport[]>(
    `contests/qwixcore-games/${qwixcoreGameId}/alert-abuse-reports/v1`,
    token,
    headers
  );
export const GetQwixcoreAbuseByBulkQwixcoreGameIdsAsync = async (
  qwixcoreGameIds: string[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameAlertAbuseReport[]>> =>
  PostAsync<Api.QwixcoreGameAlertAbuseReport[]>(
    `contests/qwixcore-games/bulk/alert-abuse-reports`,
    qwixcoreGameIds,
    token,
    headers
  );
export const CreateQwixcoreGameAlertAbuseReportAsync = async (
  abuseReport: Api.QwixcoreGameAlertAbuseReport,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameAlertAbuseReport>> =>
  PostAsync<Api.QwixcoreGameAlertAbuseReport>(
    `contests/alert-abuse-reports/v1`,
    abuseReport,
    token,
    headers
  );
export const CreateQwixcoreGameAlertAbuseReportsBulkAsync = async (
  abuseReports: Api.QwixcoreGameAlertAbuseReport[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameAlertAbuseReport[]>> =>
  PostAsync<Api.QwixcoreGameAlertAbuseReport[]>(
    `contests/alert-abuse-reports/v1`,
    abuseReports,
    token,
    headers
  );
export const DestroyQwixcoreGameAlertAbuseReportAsync = async (
  abuseReportId: number,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  PostAsync<any>(
    `contests/alert-abuse-reports/${abuseReportId}/v1`,
    null,
    token,
    headers
  );
export const DestroyQwixcoreGameAlertAbuseReportsByGameIdAsync = async (
  qwixcoreGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  PostAsync<any>(
    `contests/qwixcore-games/${qwixcoreGameId}/alert-abuse-reports/v1`,
    null,
    token,
    headers
  );
export const PurgeQwixcoreGameAlertAbuseReportCacheAsync = async (
  abuseReportId: number,
  purgeType: Api.CachePurgeType,
  qwixcoreGameId: string | null = null,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> => {
  var query = qwixcoreGameId
    ? `?qwixcoreGameId=${qwixcoreGameId}`
    : CsString.empty;

  return PostAsync<any>(
    `contests/alert-abuse-reports/${abuseReportId}/purge/${purgeType}/v1${query}`,
    null,
    token,
    headers
  );
};
export const PurgeQwixcoreGameAlertAbuseReportCacheByGameIdAsync = async (
  qwixcoreGameId: string,
  purgeType: Api.CachePurgeType,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  PostAsync<any>(
    `contests/qwixcore-games/${qwixcoreGameId}/alert-abuse-reports/purge/${purgeType}/v1`,
    null,
    token,
    headers
  );
export const GetQwixcoreGameInactivityByIdAsync = async (
  qwixcoreGameInactivityId: number,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameInactivity>> =>
  GetAsync<Api.QwixcoreGameInactivity>(
    `contests/qwixcore-game-inactivity/${qwixcoreGameInactivityId}/v1`,
    token,
    headers
  );
export const GetQwixcoreGameInactivityByQwixcoreGameIdAsync = async (
  qwixcoreGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameInactivity[]>> =>
  GetAsync<Api.QwixcoreGameInactivity[]>(
    `contests/qwixcore-games/${qwixcoreGameId}/qwixcore-game-inactivity/v1`,
    token,
    headers
  );
export const GetQwixcoreInactivityByBulkQwixcoreGameIdsAsync = async (
  qwixcoreGameIds: string[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameInactivity[]>> =>
  PostAsync<Api.QwixcoreGameInactivity[]>(
    `contests/qwixcore-games/bulk/qwixcore-game-inactivity/v1`,
    qwixcoreGameIds,
    token,
    headers
  );
export const CreateQwixcoreGameInactivityAsync = async (
  qwixcoreGameInactivity: Api.QwixcoreGameInactivity,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameInactivity[]>> =>
  PostAsync<Api.QwixcoreGameInactivity[]>(
    `contests/qwixcore-game-inactivity/v1`,
    qwixcoreGameInactivity,
    token,
    headers
  );
export const DestroyQwixcoreGameInactivityByIdAsync = async (
  qwixcoreGameInactivityId: number,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  DeleteAsync<any>(
    `contests/qwixcore-game-inactivity/${qwixcoreGameInactivityId}/v1`,
    token,
    headers
  );
export const DestroyQwixcoreGameInactivityByQwixcoreGameIdAsync = async (
  qwixcoreGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  DeleteAsync<any>(
    `contests/qwixcore-games/${qwixcoreGameId}/qwixcore-game-inactivity/v1`,
    token,
    headers
  );
export const PurgeQwixcoreGameInactivityCacheAsync = async (
  qwixcoreGameInactivityId: number,
  purgeType: Api.CachePurgeType,
  qwixcoreGameId: string | null = null,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> => {
  var queryString = CsString.empty;
  if (qwixcoreGameId && qwixcoreGameId !== CsGuid.empty) {
    queryString = `?qwixcoreGameId=${qwixcoreGameId}`;
  }

  return PostAsync<string>(
    `contests/qwixcore-game-inactivity/${qwixcoreGameInactivityId}/purge/${purgeType}/v1${queryString}`,
    null,
    token,
    headers
  );
};
export const CreateQwixcoreScorerRequestAsync = async (
  qwixcoreScorerRequest: Api.QwixcoreScorerRequest,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreScorerRequest>> =>
  PostAsync<Api.QwixcoreScorerRequest>(
    'contests/qwixcore-scorer-requests/v1',
    qwixcoreScorerRequest,
    token,
    headers
  );
export const GetQwixcoreScorerRequestByIdAsync = async (
  qwixcoreScorerRequestId: number,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreScorerRequest>> =>
  GetAsync<Api.QwixcoreScorerRequest>(
    `contests/qwixcore-scorer-requests/${qwixcoreScorerRequestId}/v1`,
    token,
    headers
  );
export const GetQwixcoreScorerRequestsByContestIdAsync = async (
  contestId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreScorerRequest[]>> =>
  GetAsync<Api.QwixcoreScorerRequest[]>(
    `contests/${contestId}/qwixcore-scorer-requests/v1`,
    token,
    headers
  );
export const GetQwixcoreScorerRequestsByBulkIdsAsync = async (
  scorerRequestIds: number[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreScorerRequest[]>> =>
  PostAsync<Api.QwixcoreScorerRequest[]>(
    `contests/qwixcore-game-scorer-requests/bulk/v1`,
    scorerRequestIds,
    token,
    headers
  );
export const GetQwixcoreScorerRequestsByBulkContestIdsAsync = async (
  contestIds: string[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreScorerRequest[]>> =>
  PostAsync<Api.QwixcoreScorerRequest[]>(
    `contests/bulk/qwixcore-scorer-requests/v1`,
    contestIds,
    token,
    headers
  );
export const PatchQwixcoreScorerRequestAsync = async (
  qwixcoreScorerRequestId: number,
  updates: any[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreScorerRequest>> =>
  PatchAsync<Api.QwixcoreScorerRequest>(
    `contests/qwixcore-scorer-requests/${qwixcoreScorerRequestId}/v1`,
    updates,
    token,
    headers
  );
export const PurgeQwixcoreScorerRequestCacheAsync = async (
  qwixcoreScorerRequestId: number,
  purgeType: Api.CachePurgeType,
  contestId: string | null = null,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> => {
  var queryString = CsString.empty;
  if (contestId !== CsGuid.empty) {
    queryString = `?contestId=${contestId}`;
  }

  return PostAsync<string>(
    `contests/qwixcore-scorer-requests/${qwixcoreScorerRequestId}/purge/${purgeType}/v1${queryString}`,
    null,
    token,
    headers
  );
};
export const CreateQwixcoreScorerRequestLogAsync = async (
  qwixcoreScorerRequestLog: Api.QwixcoreScorerRequestLog,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  PostAsync<any>(
    'contests/qwixcore-scorer-request-logs/v1',
    qwixcoreScorerRequestLog,
    token,
    headers
  );
export const GetQwixcoreScorerRequestLogsByQwixcoreScorerRequestIdAsync =
  async (
    qwixcoreScorerRequestId: number,
    token: string = '',
    headers: object | null = {}
  ): Promise<FetchResponse<Api.QwixcoreScorerRequestLog[]>> =>
    GetAsync<Api.QwixcoreScorerRequestLog[]>(
      `contests/qwixcore-scorer-requests/${qwixcoreScorerRequestId}/qwixcore-scorer-request-logs/v1`,
      token,
      headers
    );
export const PurgeQwixcoreScorerRequestLogCacheAsync = async (
  qwixcoreScorerRequestId: number,
  purgeType: Api.CachePurgeType,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> =>
  PostAsync<string>(
    `contests/qwixcore-scorer-requests/${qwixcoreScorerRequestId}/qwixcore-scorer-request-logs/purge/${purgeType}/v1`,
    null,
    token,
    headers
  );
export const CreateQwixcoreGameStateLogAsync = async (
  qwixcoreGameStateLog: Api.QwixcoreGameStateLog,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  PostAsync<any>(
    'contests/qwixcore-game-state-logs/v1',
    qwixcoreGameStateLog,
    token,
    headers
  );
export const GetQwixcoreGameStateLogsByQwixcoreGameIdAsync = async (
  qwixcoreGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.QwixcoreGameStateLog[]>> =>
  GetAsync<Api.QwixcoreGameStateLog[]>(
    `contests/qwixcore-games/${qwixcoreGameId}/qwixcore-game-state-logs/v1`,
    token,
    headers
  );
export const PurgeQwixcoreGameStateLogCacheAsync = async (
  qwixcoreGameId: string,
  purgeType: Api.CachePurgeType,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> =>
  PostAsync<string>(
    `contests/qwixcore-games/${qwixcoreGameId}/qwixcore-game-state-logs/purge/${purgeType}/v1`,
    null,
    token,
    headers
  );
export const GetCrossCountryMeetNameAsync = async (
  meetId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> => {
  var path = `contests/non-core-sports/cross-country/meets/${meetId}/meet-name/v1`;

  return GetAsync<string>(path, token, headers);
};
export const GetGolfMeetNameAsync = async (
  meetId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> => {
  var path = `contests/non-core-sports/golf/meets/${meetId}/meet-name/v1`;

  return GetAsync<string>(path, token, headers);
};
export const GetSwimMeetNameAsync = async (
  meetId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> => {
  var path = `contests/non-core-sports/swimming/meets/${meetId}/meet-name/v1`;

  return GetAsync<string>(path, token, headers);
};
export const GetTennisMeetNameAsync = async (
  meetId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> => {
  var path = `contests/non-core-sports/tennis/meets/${meetId}/meet-name/v1`;

  return GetAsync<string>(path, token, headers);
};
export const GetTrackAndFieldMeetNameAsync = async (
  meetId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> => {
  var path = `contests/non-core-sports/track-and-field/meets/${meetId}/meet-name/v1`;

  return GetAsync<string>(path, token, headers);
};
export const GetWrestlingMeetNameAsync = async (
  meetId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> => {
  var path = `contests/non-core-sports/wrestling/meets/${meetId}/meet-name/v1`;

  return GetAsync<string>(path, token, headers);
};
export const GetGameStoryByIdAsync = async (
  gameStoryId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.GameStory>> =>
  GetAsync<Api.GameStory>(
    `contests/game-stories/${gameStoryId}/v1`,
    token,
    headers
  );
export const GetGameStoryByContestIdAsync = async (
  contestId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.GameStory>> =>
  GetAsync<Api.GameStory>(
    `contests/${contestId}/game-stories/v1`,
    token,
    headers
  );
export const CreateGameStoryAsync = async (
  teamId: string,
  sportSeasonId: string,
  gameStory: Api.GameStory,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.GameStory>> =>
  PostAsync<Api.GameStory>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/game-stories/v1`,
    gameStory,
    token,
    headers
  );
export const PatchGameStoryAsync = async (
  teamId: string,
  sportSeasonId: string,
  gameStoryId: string,
  updates: any[],
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.GameStory>> =>
  PatchAsync<Api.GameStory>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/game-stories/${gameStoryId}/v1`,
    updates,
    token,
    headers
  );
export const RebuildGameStoryAsync = async (
  contestId: string,
  teamId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  PostAsync<any>(
    `contests/${contestId}/teams/${teamId}/sportseasons/${sportSeasonId}/game-stories/rebuild/v1`,
    null,
    token,
    headers
  );
export const PurgeGameStoryCacheAsync = async (
  gameStoryId: string,
  purgeType: Api.CachePurgeType,
  contestId: string | null = null,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> => {
  var queryString =
    contestId !== CsGuid.empty ? `?contestId=${contestId}` : CsString.empty;

  return PostAsync<any>(
    `contests/game-stories/${gameStoryId}/purge/${purgeType}/v1${queryString}`,
    null,
    token,
    headers
  );
};
export const PurgeGameStoryByContestCacheAsync = async (
  contestId: string,
  purgeType: Api.CachePurgeType,
  gameStoryId: string | null = null,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> => {
  var queryString =
    gameStoryId !== CsGuid.empty
      ? `?gameStoryId=${gameStoryId}`
      : CsString.empty;

  return PostAsync<any>(
    `contests/${contestId}/game-stories/purge/${purgeType}/v1${queryString}`,
    null,
    token,
    headers
  );
};
export const GetTournamentAsync = async (
  tournamentId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.Tournament>> =>
  GetAsync<Api.Tournament>(
    `contests/tournaments/${tournamentId}/v1`,
    token,
    headers
  );
export const CreateTournamentAsync = async (
  tournamentOrganizationId: string,
  tournament: Api.Tournament,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.Tournament>> =>
  PostAsync<Api.Tournament>(
    `contests/tournament-organizations/${tournamentOrganizationId}/tournaments/v1`,
    tournament,
    token,
    headers
  );
export const GetTournamentBracketAsync = async (
  tournamentBracketId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TournamentBracket>> =>
  GetAsync<Api.TournamentBracket>(
    `contests/tournament-brackets/${tournamentBracketId}/v1`,
    token,
    headers
  );
export const GetTournamentBracketsByTournamentAsync = async (
  tournamentId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TournamentBracket[]>> =>
  GetAsync<Api.TournamentBracket[]>(
    `contests/tournaments/${tournamentId}/tournament-brackets/v1`,
    token,
    headers
  );
export const GetTournamentBracketsBySportSeasonAsync = async (
  stateCode: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TournamentBracket[]>> =>
  GetAsync<Api.TournamentBracket[]>(
    `contests/tournaments/states/${stateCode}/sportseasons/${sportSeasonId}/tournament-brackets/v1`,
    token,
    headers
  );
export const CreateTournamentBracketAsync = async (
  tournamentOrganizationId: string,
  tournamentBracket: Api.TournamentBracket,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TournamentBracket>> =>
  PostAsync<Api.TournamentBracket>(
    `contests/tournament-organizations/${tournamentOrganizationId}/tournament-brackets/v1`,
    tournamentBracket,
    token,
    headers
  );
export const GetTournamentBracketRoundAsync = async (
  tournamentBracketRoundId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TournamentBracketRound>> =>
  GetAsync<Api.TournamentBracketRound>(
    `contests/tournament-bracket-rounds/${tournamentBracketRoundId}/v1`,
    token,
    headers
  );
export const GetTournamentBracketRoundsByBracketAsync = async (
  tournamentBracketId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TournamentBracketRound[]>> =>
  GetAsync<Api.TournamentBracketRound[]>(
    `contests/tournament-brackets/${tournamentBracketId}/tournament-bracket-rounds/v1`,
    token,
    headers
  );
export const CreateTournamentBracketRoundAsync = async (
  tournamentOrganizationId: string,
  tournamentBracketRound: Api.TournamentBracketRound,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TournamentBracketRound>> =>
  PostAsync<Api.TournamentBracketRound>(
    `contests/tournament-organizations/${tournamentOrganizationId}/tournament-bracket-rounds/v1`,
    tournamentBracketRound,
    token,
    headers
  );
export const GetTournamentBracketRoundMatchupAsync = async (
  tournamentBracketRoundMatchupId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TournamentBracketRoundMatchup>> =>
  GetAsync<Api.TournamentBracketRoundMatchup>(
    `contests/tournament-bracket-round-matchups/${tournamentBracketRoundMatchupId}/v1`,
    token,
    headers
  );
export const GetTournamentBracketRoundMatchupsByRoundAsync = async (
  tournamentBracketRoundId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TournamentBracketRoundMatchup[]>> =>
  GetAsync<Api.TournamentBracketRoundMatchup[]>(
    `contests/tournament-bracket-rounds/${tournamentBracketRoundId}/tournament-bracket-round-matchups/v1`,
    token,
    headers
  );
export const CreateTournamentBracketRoundMatchupAsync = async (
  tournamentOrganizationId: string,
  tournamentBracketRoundMatchup: Api.TournamentBracketRoundMatchup,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TournamentBracketRoundMatchup>> =>
  PostAsync<Api.TournamentBracketRoundMatchup>(
    `contests/tournament-organizations/${tournamentOrganizationId}/tournament-bracket-round-matchups/v1`,
    tournamentBracketRoundMatchup,
    token,
    headers
  );
export const GetTournamentBracketRoundMatchupGameAsync = async (
  tournamentBracketRoundMatchupGameId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TournamentBracketRoundMatchupGame>> =>
  GetAsync<Api.TournamentBracketRoundMatchupGame>(
    `contests/tournament-bracket-round-matchup-games/${tournamentBracketRoundMatchupGameId}/v1`,
    token,
    headers
  );
export const GetTournamentBracketRoundMatchupGamesByMatchupAsync = async (
  tournamentBracketRoundMatchupId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TournamentBracketRoundMatchupGame[]>> =>
  GetAsync<Api.TournamentBracketRoundMatchupGame[]>(
    `contests/tournament-bracket-round-matchups/${tournamentBracketRoundMatchupId}/tournament-bracket-round-matchup-games/v1`,
    token,
    headers
  );
export const CreateTournamentBracketRoundMatchupGameAsync = async (
  tournamentOrganizationId: string,
  tournamentBracketRoundMatchupGame: Api.TournamentBracketRoundMatchupGame,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TournamentBracketRoundMatchupGame>> =>
  PostAsync<Api.TournamentBracketRoundMatchupGame>(
    `contests/tournament-organizations/${tournamentOrganizationId}/tournament-bracket-round-matchup-games/v1`,
    tournamentBracketRoundMatchupGame,
    token,
    headers
  );
export const GetTournamentBracketStatesAsync = async (
  allSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TournamentBracketStateList>> =>
  GetAsync<Api.TournamentBracketStateList>(
    `contests/tournaments/allseasons/${allSeasonId}/states/v1`,
    token,
    headers
  );
export const GetTournamentBracketSportsAsync = async (
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.TournamentBracketSportList>> =>
  GetAsync<Api.TournamentBracketSportList>(
    `contests/tournaments/sports/v1`,
    token,
    headers
  );
export const GetSportSeasonBracketCountAsync = async (
  stateCode: string,
  allSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.SportSeasonBracketCount[]>> =>
  GetAsync<Api.SportSeasonBracketCount[]>(
    `contests/tournaments/states/${stateCode}/sportseasons/${allSeasonId}/count/v1`,
    token,
    headers
  );
export const PurgeByTournamentIdAsync = async (
  tournamentId: string,
  purgeType: Api.CachePurgeType,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> =>
  PostAsync<string>(
    `/contests/tournaments/${tournamentId}/purge/${purgeType}/v1`,
    null,
    token,
    headers
  );
export const PurgeByTournamentBracketIdAsync = async (
  tournamentBracketId: string,
  purgeType: Api.CachePurgeType,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> =>
  PostAsync<string>(
    `contests/tournaments/brackets/${tournamentBracketId}/purge/${purgeType}/v1`,
    null,
    token,
    headers
  );
export const PurgeByTournamentBracketRoundIdAsync = async (
  tournamentBracketRoundId: string,
  purgeType: Api.CachePurgeType,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> =>
  PostAsync<string>(
    `contests/tournaments/brackets/rounds/${tournamentBracketRoundId}/purge/${purgeType}/v1`,
    null,
    token,
    headers
  );
export const PurgeByTournamentBracketMatchupIdAsync = async (
  tournamentBracketMatchupID: string,
  purgeType: Api.CachePurgeType,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> =>
  PostAsync<string>(
    `contests/tournaments/brackets/matchups/${tournamentBracketMatchupID}/purge/${purgeType}/v1`,
    null,
    token,
    headers
  );
export const PurgeByTournamentBracketGameIdAsync = async (
  tournamentBracketGameId: string,
  purgeType: Api.CachePurgeType,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string>> =>
  PostAsync<string>(
    `contests/tournaments/brackets/games/${tournamentBracketGameId}/purge/${purgeType}/v1`,
    null,
    token,
    headers
  );
export const ConvertToSingleGameAsync = async (
  teamId: string,
  sportSeasonId: string,
  contestId: string,
  deleteContests: Boolean = false,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestTournament>> =>
  PostAsync<Api.ContestTournament>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/contests/${contestId}/convert-to-single-game/v1?deleteContests=${deleteContests}`,
    null,
    token,
    headers
  );
export const ConvertToSeriesGameAsync = async (
  teamId: string,
  sportSeasonId: string,
  contestId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ContestTournament>> =>
  PostAsync<Api.ContestTournament>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/contests/${contestId}/convert-to-series-game/v1`,
    null,
    token,
    headers
  );
export const GetScoreReportedStateRestrictionsAsync = async (
  stateId: string,
  sportSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ScoreReportedStateRestriction>> =>
  GetAsync<Api.ScoreReportedStateRestriction>(
    `contests/states/${stateId}/sportseasons/${sportSeasonId}/scores/state-restrictions/v1`,
    token,
    headers
  );
export const GetAllScoreReportedStateRestrictionsAsync = async (
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ScoreReportedStateRestriction[]>> =>
  GetAsync<Api.ScoreReportedStateRestriction[]>(
    `contests/scores/state-restrictions/v1`,
    token,
    headers
  );
export const CreateScoreReportedStateRestrictionAsync = async (
  scoreReportedStateRestriction: Api.ScoreReportedStateRestriction,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.ScoreReportedStateRestriction>> =>
  PostAsync<Api.ScoreReportedStateRestriction>(
    'contests/scores/state-restrictions/v1',
    scoreReportedStateRestriction,
    token,
    headers
  );
export const DeleteScoreReportedStateRestrictionAsync = async (
  scoreReportedStateRestrictionId: number,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  DeleteAsync<any>(
    `contests/scores/state-restrictions/${scoreReportedStateRestrictionId}/v1`,
    token,
    headers
  );
export const GetBracketMoverDataAsync = async (
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.BracketMoverData>> =>
  GetAsync<Api.BracketMoverData>(
    'contests/tournaments/bracket-mover-data/v1',
    token,
    headers
  );
export const GetGameChangerFileAsync = async (
  teamId: string,
  sportSeasonId: string,
  contestId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.GameChangerContestFile>> =>
  GetAsync<Api.GameChangerContestFile>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/contests/${contestId}/game-changer-files/v1`,
    token,
    headers
  );
export const PurgeGameChangerFileAsync = async (
  teamId: string,
  sportSeasonId: string,
  contestId: string,
  purgeType: Api.CachePurgeType,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  PostAsync<any>(
    `contests/teams/${teamId}/sportseasons/${sportSeasonId}/contests/${contestId}/game-changer-files/purge/${purgeType}/v1`,
    null,
    token,
    headers
  );
export const PurgeGameChangerFileByIdAsync = async (
  gameChangerContestFileId: string,
  purgeType: Api.CachePurgeType,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<any>> =>
  PostAsync<any>(
    `contests/game-changer-files/${gameChangerContestFileId}/purge/${purgeType}/v1`,
    null,
    token,
    headers
  );
export const TesterAsync = async (
  kbSize: number = 1,
  msTime: number = 0,
  redisChance: number = 0,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<string[]>> => {
  var path = `contests/tester/v1?kbSize=${kbSize}&msTime=${msTime}&redisChance=${redisChance}`;

  return GetAsync<string[]>(path, token, headers);
};
export const GetSportSeasonsContestCountsAsync = async (
  teamId: string,
  allSeasonId: string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<Api.SportSeasonsContestCounts>> => {
  var path = `contests/teams/${teamId}/allSeasons/${allSeasonId}/contest-counts/v1`;

  return GetAsync<Api.SportSeasonsContestCounts>(path, token, headers);
};
